/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import { useTranslation } from 'react-i18next';
import useUrlPrefix from '@app/hooks/useUrlPrefix';
import { PageType } from '@app/config';
import { usePageType } from '@app/page';

import { EVENTS, trackEvent } from '@app/segment';
import { Box, Button } from '@stockx/ui';
import { Link } from '@app/router';

interface Props {
  className?: string;
  context: string;
  title: string;
  currentLocation?: string;
  productId?: string;
  urlKey?: string;

  // the following props do not appear to ever be passed into the component when invoking
  vertical?: string;
  selectedProduct?: Record<string, any>;
  onClick?: Function;
  disabled?: boolean;
  isVerboseLang?: boolean;
}

const BidAskButton = ({
  context,
  productId = '',
  title,
  className = '',
  currentLocation = '/',
  onClick = () => {},
  vertical = '',
  disabled,
  selectedProduct,
  urlKey,
  isVerboseLang,
}: Props) => {
  const { t } = useTranslation();
  const pageType = usePageType();
  const urlPrefix = useUrlPrefix();

  const handleBidAskButtonClick = (e) => {
    trackEvent(EVENTS.NAVIGATION_ITEM_CLICKED, {
      label: t(title),
    });
    onClick(e);
  };

  let path = context === 'buying' ? `${urlPrefix}buy` : `${urlPrefix}sell`;

  if (productId) {
    path += `/${productId}`;
  }

  if (selectedProduct?.shoeSize) {
    path = `${path}?size=${selectedProduct.shoeSize}`;
  }

  if (urlKey) {
    path += `/${urlKey}`;
  }

  const linkState = disabled
    ? ''
    : {
        pathname: path,
        state: {
          prevPath: currentLocation,
          prevPageType: pageType,
          vertical,
          selectedProduct,
        },
      };

  const isHomepage = usePageType() === PageType.Home;
  const buttonWidth = !isHomepage ? '50%' : 'auto';

  return (
    <Box
      w={isVerboseLang ? '100%' : buttonWidth}
      pt={context === 'selling' && isVerboseLang ? 2 : 0}
    >
      <Link
        data-testid={'bidaskbutton'}
        to={linkState}
        className={className}
        onClick={handleBidAskButtonClick}
        disabled={disabled}
      >
        <Button
          as="span"
          tabIndex={-1}
          w="100%"
          variant={context === 'buying' ? 'primary' : 'secondary'}
        >
          {t(title)}
        </Button>
      </Link>
    </Box>
  );
};

export default BidAskButton;
